export default __webpack_public_path__ + "static/nj-laptop-b1a3e9a832d395b8f2ca3b9cb912a7c4.webp";